import React, { useRef, useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GFNButton } from '../ui/GFNButton';
import { InputText } from 'primereact/inputtext';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { fetchdata, fetchcheckdata } from './../reduxactions/fundmanagersactions/DonationsActions';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { LoginService } from '../services/LoginService';
import { Panel } from 'primereact/panel';



export const FundDonations = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')
    const data = useSelector((state: RootState) => state.fmdonation.data);
    const [showShare, setShowShare] = useState(false);
    const [selectedIDs, setSelectedIDs] = useState([]);
    const [donationSelected, setDonationSelected] = useState(null);
    const [queryParams, setQueryParams] = useState(null);
    const location = useLocation();
    const [amount, setAmount] = useState(null);

    const datas = data

    const [selectedCategories, setSelectedCategories] = useState<any>([]);


    console.log('selectedCategories', selectedCategories);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    // To get data
    useEffectOnce(() => {
        fetchDataAsync();
    }, [dispatch]);
    // const onCategoryChange = (e: CheckboxChangeEvent) => {
    //     let _selectedCategories = [...selectedCategories];
    //     console.log('_selectedCategories', _selectedCategories)


    //     if (e.checked)
    //         _selectedCategories.push(e.value);
    //     else
    //         _selectedCategories = _selectedCategories.filter(response => response.donationID !== e.value.donationID);

    //     setSelectedCategories(_selectedCategories);

    // }
    const onCategoryChange = (e: CheckboxChangeEvent) => {
        const row = e.value; // this is the full row object
        let updated = [...selectedCategories];

        if (e.checked) {
            // Add the row if not already added
            if (!updated.some(item => item.donationID === row.donationID)) {
                updated.push(row);
            }
        } else {
            // Remove the row
            updated = updated.filter(item => item.donationID !== row.donationID);
        }

        setSelectedCategories(updated);
    };
    useEffect(() => {
        const donarchat = (rowData: any) => {
            const url = `selectorg/${rowData.donationID}`;
            console.log('Row ID:', rowData.donationID);


            navigate(url);
        };


    }, [dispatch]);



    const getSelected = async () => {

        try {
            const donationID = selectedCategories.donationID;
            console.log('donationID:', donationID);

            if (typeof donationID === 'number' || typeof donationID === 'string') {
                console.log('Valid donationID:', donationID);

                await dispatch(fetchcheckdata(donationID) as any);
                const url = `/selectorg/${donationID}`;
                navigate(url);


            } else {
                console.error('Invalid donationID:', donationID);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/fmdonations.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    const isChecked = (rowData: any) => {
        console.log('rowdata', rowData)
        console.log('rowdataww2', selectedCategories.some((item: any) => item.donationID === rowData[0].donationID))

        return selectedCategories.some((item: any) => item.donationID === rowData[0].donationID)
    }
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Donation List</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="grid">
                                <div className="col-12">
                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content-end">

                                            <GFNButton buttonType="primary" label="Release Funds" rounded onClick={() => getSelected()} />
                                        </div>

                                        <div className="card flex flex-wrap justify-content-end my-2">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search ml-2" />

                                                <InputText
                                                    className="app-search-input"
                                                    value={globalFilter}
                                                    onChange={(e) => setGlobalFilter(e.target.value)}
                                                    placeholder="Global Search"
                                                />
                                            </span>
                                        </div>
                                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} selection={selectedCategories} onSelectionChange={(e: any) => setSelectedCategories(e.value)} selectionMode="checkbox">
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="CreateDate" sortable header="Date"></Column>
                                            <Column field="nameoftheorg" sortable header="Organization Name"></Column>
                                            <Column field="firstname" sortable header="Donor Name"></Column>
                                            <Column field="Amount" sortable header="Amount "></Column>
                                            <Column selectionMode='single' header="Operation" headerStyle={{ width: '1.5rem' }}></Column>
                                            {/* <Column header="Operation" body={(rowData) => (
                                                <>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div key={rowData.donationID} className="flex align-items-center">
                                                            <Checkbox inputId={rowData.donationID} name="category" value={rowData} onChange={onCategoryChange}  checked={selectedCategories.some((item: any) => item.donationID === rowData[0].donationID)} />
                                                            
                                                            
                                                        </div>

                                                    </div>
                                                </>

                                            )} /> */}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default FundDonations;